export default __webpack_public_path__ + "static/img/42.650bdd7.png";